// Resolve the account's current-dated VAT rate: prefer the account default when it is a
// current rate, else the first allowed rate that is current; null when none applies.
// Shared by buildPositionCategory and the positions list (was duplicated in both — F14).
const getCurrentVatRate = (allowedVatRates, vatList) => {
  if (allowedVatRates?.values) {
    if (vatList.find(vat => allowedVatRates.default === vat.value && vat.isCurrent)) return allowedVatRates.default
    const [currentVat] = vatList.filter(vat => allowedVatRates.values.includes(vat.value) && vat.isCurrent)
    if (currentVat) {
      return currentVat.value
    }
  }
  return null
}

export default getCurrentVatRate
